/** Stat tile exactly as in the Weekly Diary design: value, label, coloured caption, icon tile. */
const OverviewStatCard = ({ value, label, caption, captionTone = "link", icon: Icon, iconTone }) => (
  <div className="wd-stat">
    <div>
      <div className="wd-stat__value">{value}</div>
      <div className="wd-stat__label">{label}</div>
      {caption && <div className={`wd-stat__caption lp-text-${captionTone}`}>{caption}</div>}
    </div>
    {Icon && (
      <span className={`wd-stat__icon lp-tone-${iconTone}`}>
        <Icon size={18} />
      </span>
    )}
  </div>
);

export default OverviewStatCard;
